import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLongArrowAltLeft,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import email from "../assets/img/Email Campaign Ico.png";
import b2b from "../assets/img/B2B.png";
import b2c from "../assets/img/B2C.png";
import popup from "../assets/img/Popup.png";
import chat from "../assets/img/Chat.png";
import review from "../assets/img/Review.png";
import whatsapp from "../assets/img/Whatsapp.png";
import adminIcon from "../../Chat/Components/Assets/adminIcon.png";
import "./Products.css";
import WhatsappIcon from "../../Epic-X/Components/WhatsappIcon";

const Products = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tenantDB, setTenantDB] = useState(null);
  const [tenantName, setTenantName] = useState("");
  const [tenantEmail, setTenantEmail] = useState("");
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [signupStatus, setSignupStatus] = useState(null);

  // ✅ Get tenant info either from stateParam or location.state
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const stateParam = params.get("state");

    let tName, tEmail, tDB;
    if (stateParam) {
      const decodedState = JSON.parse(decodeURIComponent(stateParam));
      tName = decodedState.tenant_name;
      tEmail = decodedState.tenant_email;
      tDB = decodedState.tenantDB;
    } else if (location.state) {
      ({
        tenant_name: tName,
        tenant_email: tEmail,
        tenantDB: tDB,
      } = location.state);
    }

    if (!tName || !tEmail) {
      navigate("/login");
      return;
    }

    setTenantName(tName);
    setTenantEmail(tEmail);
    localStorage.setItem("tenantName", tName);

    // ✅ Always fetch latest tenantDB from backend
    const fetchTenant = async () => {
      try {
        const res = await fetch(
          `${
            process.env.REACT_APP_BACKEND_URL
          }/client-email?email=${encodeURIComponent(tEmail)}`
        );
        if (!res.ok) {
          navigate("/login");
          return;
        }
        const data = await res.json();
        if (!data.tentant_info) {
          navigate("/login");
          return;
        }
        setTenantDB(data.tentant_info.tenant_database);
      } catch (err) {
        console.error("Error fetching tenant:", err);
        navigate("/login");
      }
    };

    fetchTenant();
  }, [location.state, navigate]);

  const getButtonLabel = (key) => {
    return tenantDB && tenantDB[key] ? "Click Here" : "Subscribe";
  };

  // === Handlers ===
  const handleEmailClick = async (key) => {
    navigate("/contact-us");
  };

  const handleB2BClick = async (key) => {
    navigate("/contact-us");
  };

  const handleB2CClick = async (key) => {
    navigate("/contact-us");
  };

  const handlePopupClick = () => {
    window.open("https://apps.shopify.com/epic-x-popup", "_blank");
  };

  const handleChatClick = (key) => {
    if (tenantDB && tenantDB[key]) {
      navigate(`/${tenantName}/chat/dashboard`);
    } else {
      setShowChatModal(true);
      setSignupStatus(null);
    }
  };

  const handleReviewClick = async (key) => {
    window.open("https://apps.shopify.com/epic-x-review", "_blank");
  };

  const handleWhatsappClick = (key) => {
    if (tenantDB && tenantDB[key]) {
      window.location.href = `${process.env.REACT_APP_WHATSAPP_FRONTEND_URL}/${tenantName}/dashboard?tenant_name=${tenantName}&tenant_email=${tenantEmail}`;
    } else {
      setShowWhatsappModal(true);
      setSignupStatus(null);
    }
  };

  // Chat Modal Handlers
  const handleShopifyChat = () => {
    window.open("https://apps.shopify.com/chat-5", "_blank");
    setShowChatModal(false);
  };

  const handleChatWidget = async () => {
    setIsLoading(true);
    setSignupStatus(null);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/update-tenant`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            tenant_name: tenantName,
            tenant_email: tenantEmail,
            product: "Chat",
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSignupStatus("success");

        // ✅ Update tenantDB state immediately
        setTenantDB((prev) => ({
          ...prev,
          Chat: data.tenant_id,
        }));
        localStorage.setItem("isWidget",true);

        setTimeout(() => {
          setShowChatModal(false);
          setIsLoading(false);
        }, 2000);
      } else {
        setSignupStatus("error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Chat signup error:", error);
      setSignupStatus("error");
      setIsLoading(false);
    }
  };

  const handleWhatsappSignup = async () => {
    setIsLoading(true);
    setSignupStatus(null);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/update-tenant`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            tenant_name: tenantName,
            tenant_email: tenantEmail,
            product: "Whatsapp",
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSignupStatus("success");

        // ✅ Update tenantDB state immediately (no full reload)
        setTenantDB((prev) => ({
          ...prev,
          Whatsapp: data.tenant_id,
        }));

        setTimeout(() => {
          setShowWhatsappModal(false);
        }, 2000);
      } else {
        setSignupStatus("error");
      }
    } catch (error) {
      console.error("Signup error:", error);
      setSignupStatus("error");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    if (!isLoading) {
      setShowWhatsappModal(false);
      setShowChatModal(false);
      setSignupStatus(null);
    }
  };

  // Card-based Shimmer Loading Component
  const LoadingScreen = () => (
    <div className="epic-products-container">
      {/* Header Shimmer */}
      <header className="epic-products-header">
        <div className="epic-products-header-content">
          <div className="epic-products-back-button shimmer"></div>
          <div className="epic-products-user-profile">
            <div className="epic-products-avatar shimmer"></div>
            <div className="epic-products-profile-info">
              <div className="shimmer-text shimmer"></div>
              <div
                className="shimmer-text shimmer"
                style={{ width: "60px" }}
              ></div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content Shimmer */}
      <main className="epic-products-main-content">
        <div className="epic-products-inner-container">
          <div className="shimmer-title shimmer"></div>
          <div className="shimmer-subtitle shimmer"></div>

          {/* Products Grid Shimmer */}
          <div className="epic-products-grid">
            {/* Row 1 */}
            <div className="epic-products-row">
              {[1, 2, 3].map((item) => (
                <div className="epic-products-col" key={item}>
                  <div className="epic-products-card shimmer-card">
                    <div className="epic-products-card-icon shimmer"></div>
                    <div className="shimmer-card-title shimmer"></div>
                    <div className="shimmer-card-description">
                      <div className="shimmer-line shimmer"></div>
                      <div className="shimmer-line shimmer"></div>
                      <div
                        className="shimmer-line shimmer"
                        style={{ width: "80%" }}
                      ></div>
                    </div>
                    <div className="shimmer-button shimmer"></div>
                  </div>
                </div>
              ))}
            </div>

            {/* Row 2 */}
            <div className="epic-products-row">
              {[1, 2, 3].map((item) => (
                <div className="epic-products-col" key={item}>
                  <div className="epic-products-card shimmer-card">
                    <div className="epic-products-card-icon shimmer"></div>
                    <div className="shimmer-card-title shimmer"></div>
                    <div className="shimmer-card-description">
                      <div className="shimmer-line shimmer"></div>
                      <div className="shimmer-line shimmer"></div>
                      <div
                        className="shimmer-line shimmer"
                        style={{ width: "80%" }}
                      ></div>
                    </div>
                    <div className="shimmer-button shimmer"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );

  if (!tenantDB) {
    return <LoadingScreen />;
  }

  return (
    <div className="epic-products-container">
      {/* Header Section */}
      <header className="epic-products-header">
        <div className="epic-products-header-content">
          <button
            className="epic-products-back-button"
            onClick={() => navigate("/login")}
          >
            <FontAwesomeIcon icon={faLongArrowAltLeft} />
            <span>Back to Login</span>
          </button>

          <div className="epic-products-user-profile">
            <div className="epic-products-avatar">
              <img src={adminIcon} alt="Admin" />
            </div>
            <div className="epic-products-profile-info">
              <span className="epic-products-username">{tenantName}</span>
              <span className="epic-products-user-role">User</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="epic-products-main-content">
        <div className="epic-products-inner-container">
          <h1 className="epic-products-page-title">Our Products</h1>
          <p className="epic-products-page-subtitle">
            Choose from our suite of powerful marketing tools
          </p>

          {/* Products Grid */}
          <div className="epic-products-grid">
            {/* Row 1 */}
            <div className="epic-products-row">
              {/* Email Campaigns */}
              <div className="epic-products-col">
                <div
                  className="epic-products-card epic-products-card-email"
                  onClick={() => handleEmailClick("EMAIL")}
                >
                  <div className="epic-products-card-icon">
                    <img src={email} alt="Email Campaigns" />
                  </div>
                  <h3 className="epic-products-card-title">Email Campaigns</h3>
                  <p className="epic-products-card-description">
                    Create and automate email marketing campaigns to engage your
                    audience effectively.
                  </p>
                  <button
                    className={`epic-products-card-button ${
                      tenantDB?.EMAIL ? "epic-products-card-button-active" : ""
                    }`}
                  >
                    {getButtonLabel("EMAIL")}
                  </button>
                </div>
              </div>

              {/* B2B */}
              <div className="epic-products-col">
                <div
                  className="epic-products-card epic-products-card-b2b"
                  onClick={() => handleB2BClick("B2B")}
                >
                  <div className="epic-products-card-icon">
                    <img src={b2b} alt="Business to Business" />
                  </div>
                  <h3 className="epic-products-card-title">
                    Business to Business
                  </h3>
                  <p className="epic-products-card-description">
                    Streamline your B2B operations with our comprehensive
                    business solutions.
                  </p>
                  <button
                    className={`epic-products-card-button ${
                      tenantDB?.B2B ? "epic-products-card-button-active" : ""
                    }`}
                  >
                    {getButtonLabel("B2B")}
                  </button>
                </div>
              </div>

              {/* B2C */}
              <div className="epic-products-col">
                <div
                  className="epic-products-card epic-products-card-b2c"
                  onClick={() => handleB2CClick("B2C")}
                >
                  <div className="epic-products-card-icon">
                    <img src={b2c} alt="Business to Consumer" />
                  </div>
                  <h3 className="epic-products-card-title">
                    Business to Consumer
                  </h3>
                  <p className="epic-products-card-description">
                    Enhance your direct-to-customer sales with our powerful B2C
                    platform.
                  </p>
                  <button
                    className={`epic-products-card-button ${
                      tenantDB?.B2C ? "epic-products-card-button-active" : ""
                    }`}
                  >
                    {getButtonLabel("B2C")}
                  </button>
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="epic-products-row">
              {/* Popup Builder */}
              <div className="epic-products-col">
                <div
                  className="epic-products-card epic-products-card-popup"
                  onClick={() => handlePopupClick("POPUP")}
                >
                  <div className="epic-products-card-icon">
                    <img src={popup} alt="Popup Builder" />
                  </div>
                  <h3 className="epic-products-card-title">Popup Builder</h3>
                  <p className="epic-products-card-description">
                    Create high-converting popups to capture leads and boost
                    conversions.
                  </p>
                  <button
                    className={`epic-products-card-button ${
                      tenantDB?.POPUP ? "epic-products-card-button-active" : ""
                    }`}
                  >
                    {getButtonLabel("POPUP")}
                  </button>
                </div>
              </div>

              {/* Chat Automations */}
              <div className="epic-products-col">
                <div
                  className="epic-products-card epic-products-card-chat"
                  onClick={() => handleChatClick("Chat")}
                >
                  <div className="epic-products-card-icon">
                    <img src={chat} alt="Chat Automations" />
                  </div>
                  <h3 className="epic-products-card-title">Chat Automations</h3>
                  <p className="epic-products-card-description">
                    Automate customer support and engagement with AI-powered
                    chatbots.
                  </p>
                  <button
                    className={`epic-products-card-button ${
                      tenantDB?.Chat ? "epic-products-card-button-active" : ""
                    }`}
                  >
                    {getButtonLabel("Chat")}
                  </button>
                </div>
              </div>

              {/* Review Management */}
              <div className="epic-products-col">
                <div
                  className="epic-products-card epic-products-card-review"
                  onClick={() => handleReviewClick("REVIEW")}
                >
                  <div className="epic-products-card-icon">
                    <img src={review} alt="Review Management" />
                  </div>
                  <h3 className="epic-products-card-title">
                    Review Management
                  </h3>
                  <p className="epic-products-card-description">
                    Collect, monitor, and respond to customer reviews from one
                    central platform.
                  </p>
                  <button
                    className={`epic-products-card-button ${
                      tenantDB?.REVIEW ? "epic-products-card-button-active" : ""
                    }`}
                  >
                    {getButtonLabel("REVIEW")}
                  </button>
                </div>
              </div>
            </div>

            {/* Row 3 - WhatsApp Product */}
            <div className="epic-products-row">
              {/* WhatsApp Business */}
              <div className="epic-products-col">
                <div
                  className="epic-products-card epic-products-card-whatsapp"
                  onClick={() => handleWhatsappClick("Whatsapp")}
                >
                  <div className="epic-products-card-icon">
                    <img src={whatsapp} alt="WhatsApp Business" />
                  </div>
                  <h3 className="epic-products-card-title">
                    WhatsApp Business
                  </h3>
                  <p className="epic-products-card-description">
                    Connect with customers via WhatsApp for sales, support, and
                    marketing automation.
                  </p>
                  <button
                    className={`epic-products-card-button ${
                      tenantDB?.Whatsapp
                        ? "epic-products-card-button-active"
                        : ""
                    }`}
                  >
                    {getButtonLabel("Whatsapp")}
                  </button>
                </div>
              </div>

              {/* Empty columns to maintain grid structure */}
              <div className="epic-products-col"></div>
              <div className="epic-products-col"></div>
            </div>
          </div>
        </div>
      </main>

      {/* Chat Subscription Modal */}
      {showChatModal && (
        <div className="epic-modal-overlay" onClick={closeModal}>
          <div
            className="epic-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="epic-modal-header"
              style={{ background: "#4361ee" }}
            >
              <h3>Chat Automations</h3>
              <button
                className="epic-modal-close"
                onClick={closeModal}
                disabled={isLoading}
              >
                ×
              </button>
            </div>

            <div className="epic-modal-body">
              {!signupStatus ? (
                <>
                  <div className="epic-chat-options">
                    <h4>Choose Your Chat Solution:</h4>
                    <div className="epic-option-cards">
                      <div
                        className="epic-option-card"
                        onClick={handleShopifyChat}
                      >
                        <div className="epic-option-icon">🛒</div>
                        <h5>Shopify Chat</h5>
                        <p>
                          Install our Shopify app for seamless integration with
                          your store
                        </p>
                        <button className="epic-option-button">
                          Get Shopify App
                        </button>
                      </div>
                      <div
                        className="epic-option-card"
                        onClick={handleChatWidget}
                      >
                        <div className="epic-option-icon">💬</div>
                        <h5>Chat Widget</h5>
                        <p>
                          Use our standalone chat widget for any website
                          platform
                        </p>
                        <button className="epic-option-button">
                          Subscribe Now
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className={`epic-signup-status ${signupStatus}`}>
                  {signupStatus === "success" ? (
                    <>
                      <div className="epic-status-icon success">✓</div>
                      <h4>Successfully Subscribed!</h4>
                      <p>
                        Your Chat Widget account is being set up. You can now
                        access the chat dashboard.
                      </p>
                    </>
                  ) : (
                    <>
                      <div className="epic-status-icon error">✕</div>
                      <h4>Subscription Failed</h4>
                      <p>
                        There was an error processing your subscription. Please
                        try again.
                      </p>
                    </>
                  )}
                </div>
              )}
            </div>

            {isLoading && (
              <div className="epic-modal-footer">
                <div className="epic-loading-indicator">
                  <FontAwesomeIcon icon={faSpinner} spin />
                  <span>Processing your subscription...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* WhatsApp Subscription Modal */}
      {showWhatsappModal && (
        <div className="epic-modal-overlay" onClick={closeModal}>
          <div
            className="epic-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="epic-modal-header">
              <h3>WhatsApp Business</h3>
              <button
                className="epic-modal-close"
                onClick={closeModal}
                disabled={isLoading}
              >
                ×
              </button>
            </div>

            <div className="epic-modal-body">
              {!signupStatus ? (
                <>
                  <div className="epic-whatsapp-features">
                    <h4>Powerful WhatsApp Business Features:</h4>
                    <ul>
                      <li>✅ Automated messaging and chatbots</li>
                      <li>✅ Bulk messaging for marketing campaigns</li>
                      <li>✅ Analytics and reporting</li>
                      <li>✅ Template message management</li>
                      <li>✅ 24/7 customer engagement</li>
                    </ul>
                  </div>
                </>
              ) : (
                <div className={`epic-signup-status ${signupStatus}`}>
                  {signupStatus === "success" ? (
                    <>
                      <div className="epic-status-icon success">✓</div>
                      <h4>Successfully Subscribed!</h4>
                      <p>
                        Your WhatsApp Business account is being set up. You'll
                        be redirected shortly.
                      </p>
                    </>
                  ) : (
                    <>
                      <div className="epic-status-icon error">✕</div>
                      <h4>Subscription Failed</h4>
                      <p>
                        There was an error processing your subscription. Please
                        try again.
                      </p>
                    </>
                  )}
                </div>
              )}
            </div>

            <div className="epic-modal-footer">
              {!signupStatus && (
                <button
                  className={`epic-signup-button ${isLoading ? "loading" : ""}`}
                  onClick={handleWhatsappSignup}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin />
                      <span>Processing...</span>
                    </>
                  ) : (
                    "Sign Up Now"
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <WhatsappIcon />
    </div>
  );
};

export default Products;
